import { GiftSelectedOption } from '@shared/api/giftOrder/giftOrder.interface';

/** chargedUnitPrice가 필요로 하는 최소 형태 (GiftOrderItem 부분집합) */
interface ChargedUnitPriceInput {
  giftItemEmbed?: { priceRetail?: number; unitSurcharge?: number };
  selectedOptions?: GiftSelectedOption[];
}

/**
 * 구매자가 실제로 낸 **개당 단가** = 카탈로그가 + 선택옵션 추가금 + 개당 소량주문 추가금.
 *
 * 백엔드 `gift-order.surcharge.ts`의 `chargedUnitPrice`와 같은 식이며, 구매 시 결제금액을
 * 만든 `giftStore/utils/getGiftOrderDto.ts`의 계산과도 같다.
 *
 * ⚠️ `giftItemEmbed.priceRetail`은 **카탈로그가라 추가금 2종이 빠져 있다.** 환불·취소처럼
 * "구매자가 낸 돈"을 되짚는 계산에서 priceRetail만 쓰면 서버 계산액과 어긋나고,
 * 수동환불(가상계좌·입금) 부분취소는 금액이 정확히 일치해야 통과하므로 거부된다.
 */
export const chargedUnitPrice = (od: ChargedUnitPriceInput): number => {
  const optionDelta = (od.selectedOptions ?? []).reduce(
    (sum, o) => sum + (o.priceDelta || 0),
    0,
  );
  return (
    (od.giftItemEmbed?.priceRetail ?? 0) +
    optionDelta +
    (od.giftItemEmbed?.unitSurcharge ?? 0)
  );
};
